import React from 'react';
import { THEME } from '../../config/brand';

interface HomePanelProps {
  id?: string;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  /** Extra top spacing for first section under navbar */
  first?: boolean;
  overflowVisible?: boolean;
}

/** Soft cream section shell — continuous with hero, no harsh white cards */
const HomePanel: React.FC<HomePanelProps> = ({
  id,
  children,
  className = '',
  contentClassName = 'p-5 sm:p-7 lg:p-9 xl:p-10',
  first = false,
  overflowVisible = false,
}) => (
  <section
    id={id}
    className={`relative ${first ? 'pt-8 sm:pt-10 lg:pt-12' : ''} pb-5 sm:pb-6 lg:pb-8 ${className}`}
  >
    <div className="relative mx-auto max-w-[92rem] px-2 sm:px-3 lg:px-5">
      <div
        className={`relative overflow-hidden rounded-[1.5rem] border border-[#E5DCCF]/90 bg-[#FAF7F0]/85 shadow-[0_20px_50px_-28px_rgba(0,24,72,0.22)] sm:rounded-[2rem] lg:rounded-[2.25rem] ${
          overflowVisible ? '!overflow-visible' : ''
        }`}
      >
        <div className="pointer-events-none absolute inset-0" aria-hidden>
          <div
            className="absolute -start-16 top-10 h-56 w-56 rounded-full blur-3xl"
            style={{ background: `${THEME.gold}14` }}
          />
          <div
            className="absolute -end-10 bottom-0 h-64 w-64 rounded-full blur-3xl"
            style={{ background: `${THEME.navy}08` }}
          />
        </div>

        <div
          className={`relative ${contentClassName} ${overflowVisible ? 'overflow-visible' : ''}`}
        >
          {children}
        </div>
      </div>
    </div>
  </section>
);

export default HomePanel;
